<template>
  <div class="page page-invoices content">
    <h1 class="page__title">{{ t('invoices.menuTitle') }}</h1>
    <Invoices />
  </div>
</template>

<script setup>
  import Invoices from '@/components/settings/Invoices.vue'
  import { useStrings } from '@/composables/useStrings.ts'

  const { t } = useStrings()
</script>

<style lang="scss" scoped>
  .page-invoices {
    max-width: $content-page-width;
  }
</style>
